export default __webpack_public_path__ + "static/media/public.84a5516c.svg";